import {SessionUserI} from "~src/interfaces/session.types";
import {ObjectiveStatus, OwnerI} from "~src/store/okrs/interfaces";

export function canEditKeyResult(sessionUser: SessionUserI, objective: { creator: OwnerI, owners?: OwnerI[], status: ObjectiveStatus }, keyResult: { owners: OwnerI[] }): boolean {
  if (objective.status === ObjectiveStatus.CLOSED) {
    return false;
  }
  return isKeyResultEditor(sessionUser, objective, keyResult);
}

export function isKeyResultEditor(sessionUser: SessionUserI, objective: { creator: OwnerI, owners?: OwnerI[] }, keyResult: { owners: OwnerI[] }): boolean {
  const sessionUserId = sessionUser.uuid;
  const creatorUuid = objective.creator.uuid;
  const keyresultOwnerUuids = (keyResult.owners || []).map((o) => o.uuid);
  const objectiveOwnerUuids = (objective.owners || []).map((o) => o.uuid);

  return [creatorUuid]
    .concat(keyresultOwnerUuids)
    .concat(objectiveOwnerUuids)
    .some((userId) => userId === sessionUserId);
}
